import { Page, PageProps } from "@shopify/polaris";
import React, { useCallback, useRef, useState, useEffect } from "react";
import { Box } from "@novel/shared/components/Box";
import CustomBreadCrumbs from "@novel/shared/components/NovelPolarisPage/CustomBreadCrumbs";
import { useIsMobile } from "@novel/shared/hooks/useIsMobile";
import { customerGalleryPrefix } from "@novel/shared/utils/appConstants";
import { MediaMinWidths } from "@novel/shared/utils/uiConstants";
import { HamBurgerIcon, CogIcon } from "@customer-gallery/components/icons";
import { ConnectWalletModal } from "@customer-gallery/components/GalleryPageCmp/ConnectWalletModal";
import { customerRoutePush } from "@customer-gallery/definitions/routeDefinitions";
import { useNovelCustomerSelector } from "@customer-gallery/redux/reduxHooks";
import { SearchIcon, ShareIcon } from "@novel/shared/icons";
import Image from "next/legacy/image";
import Logo from "@customer-gallery-public/logo.svg";
import { useSpring, animated } from "@react-spring/web";
import { createGlobalStyle } from "styled-components";
import { successToast } from "@novel/shared/utils/toastUtils";
import { appPrefixedHostWithProtocol } from "@novel/shared/utils/appDomainConstants";
const GlobalStyle = createGlobalStyle`
body {
    background-color: #f2f7fa;
}
.ham-menu {
    display: block;
}
.logo_area {
    display: block;
}
.search-icon {
    display: block;
    cursor: pointer;
}
@media (min-width: 1024px) {
    .ham-menu {
        display: none;
    }
    .logo_area {
        display: none;
    }
    .search-icon {
        display: none;
    }
}
.Polaris-Page-Header__MainContent {
    margin-bottom: 2rem;
}

.novel-polaris-page-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
}

.Polaris-ActionMenu {
    height: 100%;
}

.Polaris-ActionMenu-Actions__ActionsLayout {
    align-items: center;
}

@media screen and (max-width: ${MediaMinWidths.Small}px) {
    .Polaris-Page-Header__RightAlign {
        margin-right: 1rem;
    }
}

@media screen and (max-width: ${MediaMinWidths.Large}px) {
    .Polaris-Page-Header__Navigation,
    .Polaris-Page-Header__MainContent {
        margin-left: 1.2rem;
    }

    .Polaris-Page-Header__RightAlign .Polaris-Button--plain {
        margin-left: 0;
        padding-left: 0;
    }

    .Polaris-Layout,
    .Polaris-Layout__Section {
        margin-left: 0;
    }
}
`;
export function CustomizeGalleryPolaris({
  children,
  setSetting,
  settingState,
  isShare,
  breadcrumbs,
  title,
  subtitle,
  titleMetadata,
  compactTitle,
  titleHidden,
  primaryAction,
  secondaryActions,
  onClickHandler,
  handleSearchChange,
  // header props which won't work atm
  // pagination,
  // actionGroups,
  // additionalNavigation,
  // additionalMetadata,
  ...otherProps
}: PageProps & {
  readonly onClickHandler?: () => void;
  readonly handleSearchChange?: (e: any) => void;
  readonly primaryAction?: boolean;
  readonly settingState?: boolean;
  readonly isShare?: boolean;
  readonly setSetting?: (state: boolean) => void;
}): JSX.Element {
  const user = useNovelCustomerSelector(state => state.auth.user);
  const cryptoAddresses = useNovelCustomerSelector(state => state.addresses.cryptoAddresses);
  const ref = useRef<any>(null);
  const [connectWalletModalOpen, setConnectWalletModalOpen] = useState(false);
  const closeConnectWalletModal = useCallback(() => setConnectWalletModalOpen(false), []);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const isMobile = useIsMobile();
  const props = useSpring({
    opacity: showSearchBar ? 1 : 0,
    from: {
      opacity: showSearchBar ? 1 : 0
    },
    config: {
      mass: 6,
      tension: 100,
      friction: 10
    }
  });
  const copyToClipboard = useCallback(() => {
    if (user) {
      navigator.clipboard.writeText(`${appPrefixedHostWithProtocol}${customerGalleryPrefix}/${user.id}`);
      successToast({
        content: "Link copied to clipboard"
      });
    } else {
      navigator.clipboard.writeText(`${window.location.href}`);
      successToast({
        content: "Link copied to clipboard"
      });
    }
  }, [user]);
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current?.contains(event.target)) {
        setShowSearchBar(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [setShowSearchBar]);
  return <React.Fragment>
            <GlobalStyle />
            <Page fullWidth {...otherProps}>
                {breadcrumbs && <div className="Polaris-Page-Header__Navigation">
                        <CustomBreadCrumbs breadcrumbs={(breadcrumbs as any)} />
                    </div>}
                <div className="Header-Wallet ">
                    <div className="Polaris-Page-Header__TitleActionMenuWrapper">
                        <div className="Polaris-Page-Header__Row">
                            <div className="Polaris-Page-Header__RightAlign">
                                {/* <MenuIcon
                                    height={30}
                                    width={30}
                                    style={{ cursor: "pointer" }}
                                    onClick={onClickHandler}
                                    className="ham-menu"
                                 /> */}
                                <HamBurgerIcon style={{
                cursor: "pointer"
              }} onClick={onClickHandler} className="ham-menu" />
                                {!showSearchBar && <div className="logo_area">
                                        <Image src={Logo} alt="Logo" objectFit="contain" width={100} height={30} />
                                    </div>}
                                {showSearchBar ? <animated.div style={props} className="search-box-bar-mobile" ref={ref}>
                                        <SearchIcon />
                                        <input className="searchBar" type="search" placeholder="Search" onChange={handleSearchChange} />
                                    </animated.div> : <span className="search-icon" onClick={() => setShowSearchBar(!showSearchBar)}>
                                        <SearchIcon />
                                    </span>}

                                <div className="search-box-bar">
                                    <SearchIcon />
                                    <input className="searchBar" type="search" placeholder="Search" onChange={handleSearchChange} />
                                </div>
                                {primaryAction && <div className="Polaris-Page-Header__PrimaryActionWrapper">
                                        <Box columnGap={1.5} style={{
                  width: isMobile ? "100%" : "auto"
                }}>
                                            {!isShare && <React.Fragment>
                                                    {setSetting && <button onClick={() => setSetting(!settingState)} className="fixed-button">
                                                            <Box style={{
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center"
                      }} columnGap={1}>
                                                                <CogIcon />
                                                            </Box>
                                                        </button>}
                                                    <button onClick={() => customerRoutePush("/manage")} className="full-button">
                                                        <Box style={{
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center"
                      }} columnGap={1}>
                                                            <CogIcon /> Manage
                                                        </Box>
                                                    </button>
                                                </React.Fragment>}
                                            <button onClick={copyToClipboard} className="full-button">
                                                <Box style={{
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center"
                    }} columnGap={1}>
                                                    <ShareIcon /> Share
                                                </Box>
                                            </button>
                                            {!user && <React.Fragment>
                                                    <button onClick={() => customerRoutePush("/login")} className="full-button">
                                                        <Box style={{
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center"
                      }} columnGap={1}>
                                                            Login
                                                        </Box>
                                                    </button>
                                                    <button onClick={() => customerRoutePush("/sign-up")} className="edit-text">
                                                        <Box style={{
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center"
                      }} columnGap={1}>
                                                            Sign Up
                                                        </Box>
                                                    </button>
                                                </React.Fragment>}
                                        </Box>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="novel-polaris-page-wrapper">{children}</div>
                <div className="footer-wrapper-custom">
                    <div className="footer-container">
                        <div className="copyright-container">© Novel Commerce Inc.</div>
                        <div className="legal-links-container">
                            <a className="legal-link-container" href="https://novel.com/terms" target="_blank">
                                Terms & Privacy
                            </a>
                        </div>
                    </div>
                </div>

                {user && (connectWalletModalOpen || !cryptoAddresses.length) && <ConnectWalletModal user={user} onClose={closeConnectWalletModal} isFirstWallet={!cryptoAddresses.length} />}
            </Page>
        </React.Fragment>;
}